module.exports = __webpack_public_path__ + "img/baixar_appstore.8c15379d.svg";